import React from "react";
import type { RfxListTab } from "../../types/rfx-list.type";
import { getTendersQuotesEmptyStateCopy } from "./tendersQuotesTabAssertion";

export const TendersQuotesEmptyState = ({ tab }: { tab: RfxListTab }) => (
	<p className="text-sm text-gray-500" data-testid="tenders-quotes-empty-copy">
		{getTendersQuotesEmptyStateCopy(tab)}
	</p>
);
